<template>
    <div class="card">
        <div class="card-inner">
            <!--<div class="card-background"></div>-->
            <div class="title-container">
                    <span class="icon">
                        <slot name="icon"></slot>
                    </span>
                <span class="title">
                        <slot name="title"></slot>
                    </span>
            </div>
            <div class="content-container">
                <slot></slot>
            </div>
        </div>
        <div class="more-infos">
            <slot name="moreInfos"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CardSimple',
        props: [],
        data: () => ({
            pourcent: 1
        })
    }
</script>

<style lang="scss" scoped>
.card-inner{
  height: 100%;
}
</style>
